export const PAGE_LOAD_EVENT = 'PAGE_LOAD';
export const ACCORDION_EXPAND_EVENT = 'ACCORDION_EXPANDED';
export const SHOW_MORE_BUTTON_CLICKED = 'SHOW_MORE_BUTTON_CLICKED';
export const MODEL_DROPDOWN_SELECTED = 'MODEL_DROPDOWN_SELECTED';
export const SEARCH_BTN_CLICKED = 'SEARCH_BTN_CLICKED';
export const ITEMS_PER_PAGE_SELECTED = 'ITEMS_PER_PAGE_SELECTED';
export const PAGE_NUMBER_CLICKED = 'PAGE_NUMBER_CLICKED';
export const DOWNDLOAD_LINK_CLICKED = 'DOWNDLOAD_LINK_CLICKED';
export const NDA_DOWNLOAD_LINK_CLICKED = 'NDA_DOWNLOAD_LINK_CLICKED';
export const SUBMIT_BUTTON_CLICKED = 'SUBMIT_BUTTON_CLICKED';
export const FORM_SUBMISSION_SUCCESS_EVENT = 'FORM_SUBMISSION_SUCCESS';
export const CALL_EMAIL_EVENT = 'CALL_EMAIL';
export const EXIT_TO_BBAS_EVENT = 'EXIT_TO_BBAS';
export const CAD2D_SEARCH_BUTTON_CLICKED = '2D_FILE_SEARCH';
export const UNSUBSCRIBE_BTN_EVENT = 'UNSUBSCRIBE_BTN_CLICKED';
export const SUBSCRIBE_BTN_EVENT = 'SUBSCRIBE_BTN_CLICKED';
export const UIS_EXIT_TO_TUTORIAL_EVENT = 'UIS_EXIT_TO_TUTORIAL';
export const FAQ_EXPAND_EVENT = 'FAQ_EXPAND';
export const EXIT_VIA_FAQ_EVENT = 'EXIT_VIA_FAQ';
export const UIS_DOWNLOAD_EVENT = 'UIS_DOWNLOAD';
export const UIM_DOWNLOAD_EVENT = 'UIM_DOWNLOAD';
export const SIGN_IN_AND_DOWNLOAD_EVENT = 'SIGN_IN_AND_DOWNLOAD';

/* ************************************************************************************************* */
// this is used to include metadat in download name
// Don't insert metadata values in the middle of below string, always APPEND (at the end)
// must end string with a separator '|'
export const DOWNLOAD_METADATA_TO_REPLACE =
  '<title>|<document_type>|<nameplate>|<language>|<year>|<quarter>|<body_style>|<wheel_base>|<drive_type>|<rear_wheels>|<roof_height>|<rear_doors>|<category>|';
export const SHORT_DOWNLOAD_METADATA_TO_REPLACE = '<title>|<year>|<language>|';
export const SHORT_DOWNLOAD_CAD_METADATA_TO_REPLACE =
  '<title>|<year>|<nameplate>|<body_style>|<wheel_base>|';

/* ************************************************************************************************* */

export const ANALYTICS_PAGES = {
  PUBLICATIONS: 'publications-page',
  CAD: 'cad-form',
  CONTACTUS: 'contactus-form',
  PRO_UPFITTER_PAGE: 'pro-upfitter-page',
  THANK_YOU_PAGE: 'thank-you-page',
  UNSUBSCRIBE_PAGE: 'unsubscribe-page',
  LANDING_PAGE: 'landing-page',
  EU_PUBLICATIONS: 'eu-publications-page',
  EU_CAD: 'eu-cad-form',
  EU_CONTACTUS: 'eu-contactus-form',
  EU_LANDING_PAGE: 'eu-landing-page',
  EU_DIGIBEMM_PAGE: 'eu-digibemm-page',
  EU_UNSUBSCRIBE_PAGE: 'eu-unsubscribe-page',
};

export const onClickValuesToReplace =
  /<CTA>|{button name}|{link text}|<url>|<name>|<button_position>|<download_name>|<download name>|<file name>|<call_email>|<callemail>|<external_website>|<accordion name>|<dropdown_option>|<dropdown option>|<short download name>|<fileID>|<search term>|<hostname>/g;

export const MARKET_DIGITALDATA_MAP = {
  'en-us': {
    lang: 'eng',
    client: 'fpro-us',
    site: 'pro.ford.com',
  },
  'en-ca': {
    lang: 'eng',
    client: 'fpro-can',
    site: 'pro.ford.ca',
  },
  'fr-ca': {
    lang: 'fre',
    client: 'fpro-can',
    site: 'pro.ford.ca',
  },
  'en-gb': {
    lang: 'eng',
    client: 'ford-gb',
    site: 'ford-pro',
  },
  'de-de': {
    lang: 'deu',
    client: 'ford-de',
    site: 'ford-pro',
  },
  'fr-fr': {
    lang: 'fra',
    client: 'ford-fr',
    site: 'ford-pro',
  },
  'it-it': {
    lang: 'ita',
    client: 'ford-it',
    site: 'ford-pro',
  },
  'es-es': {
    lang: 'spa',
    client: 'ford-es',
    site: 'ford-pro',
  },
  'nl-nl': {
    lang: 'dut',
    client: 'ford-nl',
    site: 'ford-pro',
  },
  'en-ie': {
    lang: 'eng',
    client: 'ford-ie',
    site: 'ford-pro',
  },
  'de-at': {
    lang: 'deu',
    client: 'ford-at',
    site: 'ford-pro',
  },
  'fr-ch': {
    lang: 'fra',
    client: 'ford-ch',
    site: 'ford-pro',
  },
  'it-ch': {
    lang: 'ita',
    client: 'ford-ch',
    site: 'ford-pro',
  },
  'de-ch': {
    lang: 'deu',
    client: 'ford-ch',
    site: 'ford-pro',
  },
  'no-no': {
    lang: 'nor',
    client: 'ford-no',
    site: 'ford-pro',
  },
  'pl-pl': {
    lang: 'pol',
    client: 'ford-pl',
    site: 'ford-pro',
  },
  'nl-be': {
    lang: 'dut',
    client: 'ford-be',
    site: 'ford-pro',
  },
  'fr-be': {
    lang: 'fra',
    client: 'ford-be',
    site: 'ford-pro',
  },
  'da-dk': {
    lang: 'dan',
    client: 'ford-dk',
    site: 'ford-pro',
  },
  'fi-fi': {
    lang: 'fin',
    client: 'ford-fi',
    site: 'ford-pro',
  },
  'el-gr': {
    lang: 'ell',
    client: 'ford-gr',
    site: 'ford-pro',
  },
  'hu-hu': {
    lang: 'hun',
    client: 'ford-hu',
    site: 'ford-pro',
  },
  'sv-se': {
    lang: 'swe',
    client: 'ford-se',
    site: 'ford-pro',
  },
  'ro-ro': {
    lang: 'rum',
    client: 'ford-ro',
    site: 'ford-pro',
  },
  'pt-pt': {
    lang: 'por',
    client: 'ford-pt',
    site: 'ford-pro',
  },
  'tr-tr': {
    lang: 'tur',
    client: 'ford-tr',
    site: 'ford-pro',
  },
  'cs-cz': {
    lang: 'ces',
    client: 'ford-cz',
    site: 'ford-pro',
  },
};

export interface CookiePreferencesType {
  strictly_necessary: boolean;
  performance: boolean;
  functionality: boolean;
  targeting: boolean;
  social_media: boolean;
}

export const ALL_VALUE_FOR_MARKETS = ['all', 'alle', 'todos', 'tout', 'tutti', 'wszystko'];
